import { render, staticRenderFns } from "./ReleaseDetail.vue?vue&type=template&id=33d276dc"
import script from "./ReleaseDetail.vue?vue&type=script&lang=js"
export * from "./ReleaseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports